import * as React from 'react';
import './index.scss';
import Pop from './Pop';
import { HYRouter, HYToast } from '@hy-hybrid/kiwi-js-sdk';
import { canOpen } from './../../../utils';
interface PopInterface {
  close: any;
}
const { showToast } = HYToast;
const PopWechat: React.FC<PopInterface> = (props) => (
  <Pop>
    <div className="pop-wechat">
      <i className="close" onClick={() => props.close()} />
      <h3>邀请口令复制成功</h3>
      <p>打开微信，选择好友粘贴吧</p>
      <div
        className="wechat"
        onClick={() => {
          const message = '请安装微信后再使用此功能哦';
          canOpen('weixin').then((rsp) => {
            console.log('canOpen的返回: ', rsp);
            try {
              if (rsp) {
                const isPad =
                  (navigator.userAgent.toLowerCase().match(/iPad/i) as any) ==
                  'ipad';
                if (isPad) {
                  HYRouter.openUrl({
                    url: 'weixin://',
                  });
                } else {
                  window.open('weixin://');
                }
                // window.location.href = 'weixin://';
              } else {
                showToast({
                  message,
                });
              }
            } catch (error) {
              console.log('打开出错', error);
            }
          });
        }}
      />
    </div>
  </Pop>
);

export default PopWechat;
